import Chart from "react-apexcharts";

const DEFAULT_COLORS = ["#2152FF", "#22c55e", "#f59e0b", "#ef4444", "#8b5cf6"];

const TimeseriesChart = ({
  series = [],
  type = "area",
  height = 280,
  stacked = false,
  colors = DEFAULT_COLORS,
  yFormatter,
}) => {
  if (!Array.isArray(series) || series.length === 0) return null;
  const categories = series[0]?.data?.map((d) => d.date) || [];
  const apexSeries = series.map((s) => ({
    name: s.name,
    data: (s.data || []).map((d) => Number(d.value) || 0),
  }));

  const options = {
    chart: {
      type,
      stacked,
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: "Cairo, DM Sans, sans-serif",
    },
    colors,
    stroke: { curve: "smooth", width: 2 },
    fill:
      type === "area"
        ? {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.3,
              opacityTo: 0.05,
              stops: [0, 100],
            },
          }
        : { type: "solid" },
    dataLabels: { enabled: false },
    grid: { borderColor: "#E2E8F0", strokeDashArray: 4 },
    xaxis: {
      categories,
      labels: {
        style: { colors: "#707EAE", fontSize: "11px" },
        rotate: 0,
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: { colors: "#707EAE", fontSize: "11px" },
        formatter: yFormatter,
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      fontSize: "12px",
      labels: { colors: "#252f40" },
    },
    tooltip: {
      theme: "light",
      x: { format: "yyyy-MM-dd" },
    },
  };

  return (
    <Chart
      options={options}
      series={apexSeries}
      type={type}
      height={height}
    />
  );
};

export default TimeseriesChart;
